function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { filterObjectByKey } from "./objectTools";

/**
 * We want to authorize globally some attribute families to facilitate the usage of those attributes
 * without being forced to declare each one individually in every component.
 *
 * Other global attributes that can have a real impact in the behaviour of the component should be declared in
 * component's proptypes. Like: onClick, alt, src...
 *
 * @type {RegExp[]}
 */
var AUTHORIZED_REST_PROPS = [
// All a11y-related attributes
/^aria-/, /^role$/, /^tabIndex$/,
// All Data attributes
/^data-/,
// Microdata attributes
/^itemid$/, /^itemprop$/, /^itemref$/, /^itemscope$/, /^itemtype$/];

/**
 * Filter rest props to only let pass the authorized ones.
 *
 * @param {Object} restProps - Unfiltered rest props
 * @return {Object} Filtered rest props
 */
export var getAuthorizedRestProps = function getAuthorizedRestProps(restProps) {
  return AUTHORIZED_REST_PROPS.reduce(function (authorizedRestProps, propRegExp) {
    return _objectSpread(_objectSpread({}, authorizedRestProps), filterObjectByKey(restProps, propRegExp));
  }, {});
};

/**
 * Filter component props to only let pass the authorized ones.
 *
 * @param {Object} componentProps all or rest component props
 * @param {Object} componentPropTypes propTypes component
 * @returns {Object} Filtered component props
 */
export var getAuthorizedComponentProps = function getAuthorizedComponentProps(componentProps, componentPropTypes) {
  return Object.keys(componentPropTypes).reduce(function (authorizedComponentProps, propName) {
    return _objectSpread(_objectSpread({}, authorizedComponentProps), componentProps[propName] && _defineProperty({}, propName, componentProps[propName]));
  }, {});
};